// debugLogger.js
export const createLogger = (filepath) => {
    let isDebug = false;

    // Extract just the filename from the path
    const filename = filepath.split('/').pop();

    const formatMessage = (args) => {
        const time = new Date().toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        return [`[${time} ${filename}]\n`, ...args];
    };

    const log = (...args) => {
        if (isDebug) {
            console.log(...formatMessage(args));
        }
    };

    const error = (...args) => {
        if (isDebug) {
            console.error(...formatMessage(args, 'ERROR'));
        }
    };

    const warn = (...args) => {
        if (isDebug) {
            console.warn(...formatMessage(args, 'WARN'));
        }
    };

    const setDebug = (enabled) => {
        isDebug = enabled;
    };

    return {
        log,
        error,
        warn,
        setDebug
    };
};